export default {
  lotteryId(state) {
    return state.lotteryId;
  },
  token(state) {
    return state.token;
  },
  mobile(state) {
    return state.mobile;
  },
  backgroud(state) {
    return state.backgroud;
  },
  rule(state) {
    return state.rule;
  },
  title(state) {
    return state.title;
  },
  adNum(state) {
    return state.adNum;
  },
};
